.dashboard {
	display: flex;
	flex-wrap: wrap;

	@media screen and (max-width: 750px) {
		flex-direction: column;
	}

	.dashboard_row {
		width: 100%;
		margin-left: 0px;

		.container {
			padding: 8px;
			margin: 5px;
			background-color: white;
			border-radius: 12px;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
		}

		.cardHeader {
			display: flex;
			align-items: center;
			gap: 8px;
			margin-bottom: 4px;
			padding-left: 4px;

			.cardTitle {
				font-size: 14px;
				font-weight: 600;
				color: #374151;
			}

			.iconTitle {
				color: #7fb02f;
			}

			.dragIcon {
				cursor: grab;
				color: #9ca3af;
				display: flex;
				align-items: center;

				&:hover {
					color: #6b7280;
				}
			}
		}

		.dashboard_col {
			display: flex;
			padding-right: 0px;
			padding-left: 0px;

			@media screen and (max-width: 750px) {
				flex-direction: column;
			}

			.dashboard_column {
				width: 50%;

				.dashboard_content {
					width: 100%;
					height: 100%;

					.cardDragHandle {
						cursor: grab;
						width: 100%;
						height: 12px;
						background-color: #eee;
						border-radius: 4px 4px 0 0;
						margin-bottom: 4px;
					}
				}

				@media screen and (max-width: 1250px) {
					width: 50%;
				}

				@media screen and (max-width: 750px) {
					width: 100%;
				}
			}

			.card {
				width: 100%;
				padding: 4px;

				.content {
					background: #fff;
					border-radius: 10px;
					--tw-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
					--tw-shadow-colored: 0px 0px 1px var(--tw-shadow-color), 0px 0.5px 2px var(--tw-shadow-color);
					box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
					height: 40vh;
					padding: 5px 10px;

					.title {
						font-size: 16px;
						font-weight: 700;
						text-align: center;
						margin-bottom: 10px;
						position: relative;

						.title_option {
							position: absolute;
							right: 0;
							top: 0;
							border: 1px solid black;
							width: 1.5em;
							height: 1.5em;
							border-radius: 5px;
							background-size: 50px 20px;
							background-repeat: no-repeat;
							background-position: center;
							background-image: url("../../assets/images/desktop/options.svg");
						}
					}

					.subtitle {
						margin-top: -4px;
						font-size: 13px;
						text-align: center;
					}

					.icon {
						height: 33%;
						display: flex;
						justify-content: center;
						align-items: center;

						@media screen and (max-width: 1500px) {
							height: 25%;
						}
					}

					.metrics {
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						height: 65%;

						.text {
							font-size: 16px;

							@media screen and (max-width: 1000px) {
								font-size: 13px;
							}
						}

						.number {
							font-weight: 600;
							font-size: 35px;

							&.number_error {
								color: #dc3535e3;
							}

							@media screen and (max-width: 1000px) {
								font-size: 25px;
							}
						}
					}

					.progress_valorization {
						width: 100%;
						background-color: #e6e6e6;
						border-radius: 5px;

						.valued {
							width: 0%;
							background-color: #7fb02f;
							border-radius: 5px;
							min-height: 0.6em;
						}
					}

					.progress_valorization_span {
						display: flex;
						justify-content: space-between;
						font-size: 12px;

						.valued_button {
							cursor: pointer;
							text-decoration: underline;
						}
					}

					.filter {
						position: relative;
						margin-bottom: 10px;

						.filter_type {
							display: flex;
							justify-content: center;
							align-items: center;
							margin-bottom: 5px;

							.type_quantity {
								background: #bbbbbb;
								color: white;
								min-width: 7em;
								padding-left: 10px;
								border-top-left-radius: 10px;
								border-bottom-left-radius: 10px;
								text-align: left;
								border-right: 0.5px solid white;
								cursor: pointer;
								font-size: 13px;

								&:hover {
									background-color: #7fb02f;
								}

								&.active {
									background-color: #7fb02f;
								}
							}

							.type_price {
								background: #bbbbbb;
								color: white;
								min-width: 7em;
								padding-right: 10px;
								border-top-right-radius: 10px;
								border-bottom-right-radius: 10px;
								text-align: right;
								border-left: 0.5px solid white;
								cursor: pointer;
								font-size: 13px;

								&:hover {
									background-color: #7fb02f;
								}

								&.active {
									background-color: #7fb02f;
								}
							}
						}

						.filter_div {
							display: flex;
							justify-content: center;

							.filter_button {
								color: white;
								background-color: #7fb02f;
								border-radius: 10px;
								font-size: 13px;
								padding: 2px 7px;
								cursor: pointer;

								&:hover {
									background-color: #5a8217;
								}
							}
						}

						.filter_content {
							position: absolute;
							top: 30px;
							border-radius: 10px;
							box-shadow: 5px 5px 5px #3d482a4a;
							max-width: 25em;
							z-index: 100;

							.filter_years {
								display: flex;
								justify-content: space-between;
								margin-bottom: 6px;

								.filter_year {
									font-weight: 600;
									font-size: 20px;
								}

								.filter_icon {
									width: 1em;
									height: 1em;
									cursor: pointer;
								}
							}

							.filter_months {
								display: flex;
								flex-direction: row;
								flex-wrap: wrap;

								.filter_month {
									width: 25%;
									padding: 5px;
									cursor: pointer;

									.filter_month_name {
										font-size: 13px;
										display: flex;
										min-height: 3em;
										justify-content: center;
										align-items: center;
										border-radius: 5px;
										background-color: #f8f9fa;
										color: #7fb02f;
										border: 1px solid #7fb02f;

										&.active {
											background-color: #7fb02f;
											color: white;
										}
									}
								}
							}

							.filter_apply {
								display: flex;
								justify-content: flex-end;

								.filter_button_apply {
									margin-top: 3px;
									background-color: #7fb02f;
									color: white;
									border-radius: 5px;
									padding: 5px 40px;
									font-size: 14px;
									cursor: pointer;

									&:hover {
										background-color: #5a8217;
									}
								}
							}
						}
					}

					.graph {
						margin-top: 10px;
						height: 50%;
					}

					.graph_filter {
						margin-top: 10px;
						height: 70%;
					}

					.graph_only {
						margin-top: 10px;
						height: 80%;
					}

					.style_table {
						height: 80%;

						@media screen and (max-width: 1500px) {
							height: 75%;
						}

						.style_table_title {
							width: 100%;
							text-align: center;
							margin-top: 10px;

							.table_th {
								font-size: 13px;

								@media screen and (max-width: 1500px) {
									font-size: 12px;
								}
							}
						}

						.style_table_body {
							width: 100%;
							background-color: #fafafa;
							border-radius: 5px;
							font-size: 12px;
							text-align: center;
							margin-top: 10px;

							@media screen and (max-width: 1500px) {
								margin-top: 5px;
								font-size: 11px;
							}

							td {
								padding: 7px 0px;

								@media screen and (max-width: 1500px) {
									padding: 5px 0px;
								}
							}
						}
					}

					.footer {
						height: 10%;
						display: flex;
						justify-content: flex-end;

						.footer_text {
							cursor: pointer;
							text-decoration: underline;
							font-size: 13px;
							font-weight: 500;

							&:hover {
								color: #7fb02f;
							}
						}
					}

					.graph_pie {
						display: flex;

						.graph_pie_graph {
							display: flex;
							justify-content: center;
							align-items: center;
							width: 50%;
							height: 30vh;
						}

						.graph_pie_table {
							padding-left: 5px;
							width: 50%;
							overflow-y: auto;
							max-height: 30vh;

							&::-webkit-scrollbar {
								width: 5px;
								height: 5px;
							}

							&::-webkit-scrollbar-track {
								background: #f1f1f1;
							}

							&::-webkit-scrollbar-thumb {
								background-color: #a8a8a8;
								border-radius: 15px;
							}

							.graph_text {
								font-size: 12px;
								margin-bottom: 15px;
							}
						}
					}

					// Custom
					.expiration {
						height: 80%;
						padding: 0px 10px;

						.expiration_div {
							display: flex;
							justify-content: space-between;

							@media screen and (max-width: 1500px) {
								font-size: 13px;
							}

							.expiration_text {
								width: 50%;
							}

							.expiration_quantity {
								text-align: right;
								width: 25%;
								font-weight: 500;
							}

							.expiration_percentage {
								text-align: right;
								width: 25%;
							}
						}

						.expiration_bar {
							width: 100%;
							height: 1em;
							background: #e4e5ed;
							border-radius: 10px;
							margin-top: 5px;
							margin-bottom: 10px;

							@media screen and (max-width: 1500px) {
								height: 0.5em;
							}
						}
					}
				}
			}
		}
	}
}

// Estilos modernos para el modal de actualización
.updateModalContent {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 2rem 0 1.5rem;
	gap: 1.5rem;
}

.updateIconWrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}

.updateIconBg {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 72px;
	height: 72px;
	border-radius: 50%;
	background: linear-gradient(135deg, #7fb02f 0%, #6a9625 100%);
	box-shadow: 0 10px 25px rgba(127, 176, 47, 0.25);
	position: relative;

	&::before {
		content: "";
		position: absolute;
		inset: -4px;
		border-radius: 50%;
		background: linear-gradient(135deg, rgba(127, 176, 47, 0.1) 0%, rgba(106, 150, 37, 0.1) 100%);
		z-index: -1;
	}
}

.updateIcon {
	color: white;
	animation: bellRing 2s ease-in-out infinite;
}

@keyframes bellRing {
	0%,
	100% {
		transform: rotate(0deg);
	}
	10%,
	30% {
		transform: rotate(-10deg);
	}
	20%,
	40% {
		transform: rotate(10deg);
	}
	50% {
		transform: rotate(0deg);
	}
}

.updateTextContent {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	gap: 0.75rem;
	width: 100%;
	max-width: 450px;
}

.updateTitle {
	font-size: 1.5rem;
	font-weight: 600;
	color: #1f2937;
	margin: 0;
	line-height: 1.3;
	letter-spacing: -0.02em;
}

.updateMessage {
	font-size: 1rem;
	font-weight: 400;
	color: #6b7280;
	margin: 0;
	line-height: 1.6;
}

.updateDetails {
	width: 100%;
	margin-top: 0.5rem;
	padding: 1rem;
	background: #f9fafb;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
	text-align: left;

	ul {
		margin: 0;
		padding-left: 1.25rem;

		li {
			font-size: 0.9rem;
			color: #4b5563;
			line-height: 1.6;
			margin-bottom: 0.5rem;

			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	p {
		margin: 0;
		font-size: 0.9rem;
		color: #4b5563;
		line-height: 1.6;
	}
}

.updateModalFooter {
	display: flex;
	gap: 0.75rem;
	width: 100%;
	justify-content: flex-end;
}

// Estilos antiguos del modal (mantener por compatibilidad)
.modal_body {
	display: flex;
	flex-direction: column;

	.icon_container {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;

		.notification_icon {
			height: 6rem;
			width: 6rem;
		}
	}

	h4 {
		font-weight: 300;
		text-align: center;
	}
	div {
		display: block;
		justify-content: space-around;
		padding: 1rem 0;
		button {
			background-color: #7fb02f;
			border: none;
			padding: 0.5rem;
			margin: 0.5rem 0;
			border-radius: 50px;
			color: #fff;
			width: 100%;

			&:hover {
				background-color: #5f8521;
				cursor: pointer;
			}

			a {
				color: #fff;
				&:hover {
					text-decoration: none;
				}
			}
		}
	}

	.check_input {
		display: flex;
		margin: 1rem 0;
		justify-content: flex-start;
		cursor: pointer;

		label {
			margin: 0;
			cursor: pointer;
		}
	}
}

.mainFilter {
	.filterTitle {
		margin-top: 15px;
		font-size: 15px;
	}

	.filterHr {
		margin-top: 1px;
		margin-bottom: 1px;
		border-top: 1px solid #7fb02f;
	}

	.divContent {
		height: 70vh;
		overflow-y: auto;
		overflow-x: hidden;

		&::-webkit-scrollbar {
			width: 5px;
			height: 5px;
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
		}

		&::-webkit-scrollbar-thumb {
			background-color: #a8a8a8;
			border-radius: 15px;
		}

		.divForm {
			margin-top: 10px;

			.divLabel {
				margin-bottom: 4px;
				display: flex;
				align-items: center;

				.label {
					font-weight: 500;
					font-size: 14px;
				}
			}
		}
	}

	.divFooter {
		display: flex;
		justify-content: space-evenly;
		padding-top: 7px;

		.buttonClean {
			padding: 2px 15px;
			font-size: 13px;
			font-weight: 500;

			background-color: white !important;
			color: #81ba43 !important;

			&:hover {
				background-color: #5d9125 !important;
				color: white !important;
			}
		}

		.buttonApply {
			padding: 2px 15px;
			font-size: 13px;
			font-weight: 500;
		}
	}
}

.table_div {
	width: 50%;

	.table_button {
		width: 95%;
		font-size: 13px;
		background-color: #81ba43;
		border-radius: 5px;
		padding: 8px 10px;
		cursor: pointer;
		border: 1px solid #81ba43;
		color: white;
		text-align: center;

		&:hover {
			background-color: #5d9125;
			border: 1px solid #5d9125;
		}

		&.active {
			background-color: white;
			color: #81ba43;
			border: 1px solid #81ba43;
		}

		&.fetching {
			background-color: #dee2e6;
			color: #5e5e5e;
			border: 1px solid #a8a8a8;
		}
	}
}

.table_dashboard {
	.th {
		background-color: #81ba43;
		padding: 5px;
		font-weight: 400;
		border: none;
		color: white;
		text-align: center;
	}

	.td {
		font-size: 13px;
		padding: 5px;

		&.center {
			text-align: center;
		}
	}

	.button_confirm {
		display: flex;
		justify-content: center;
		padding: 6px;
	}
}

.button_search {
	background-color: #7fb02f;
	width: 100%;
	border-radius: 5px;
	text-align: center;
	color: white;
	cursor: pointer;
	padding: 7px 5px 7px 5px;
	margin: 0px 5px 0px 5px;

	&:hover {
		background-color: #5a8217;
	}
}
